<script setup lang="ts">
/**
 * 404。
 *
 * 原实现没有 `not-found.tsx`，用的是 Next 内置的 404 页；
 * 换成 SPA 后必须自己有一个，否则输错地址会是一张白屏。
 * 文案与按钮跟站内其它空状态保持一致。
 */

import AppFooter from '../components/layout/AppFooter.vue';
import Button from '../components/ui/Button.vue';
</script>

<template>
  <div class="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center px-4 py-16 text-center">
    <p class="text-5xl font-semibold tracking-tight text-slate-300">404</p>
    <h1 class="mt-4 text-lg font-semibold text-slate-900">页面不存在</h1>
    <p class="mt-2 max-w-md text-sm leading-relaxed text-slate-600">
      这个地址可能已经失效，或者链接被复制时少了几个字符。
    </p>
    <div class="mt-6 flex flex-wrap justify-center gap-3">
      <RouterLink to="/"><Button>回到首页</Button></RouterLink>
      <RouterLink to="/chat"><Button variant="secondary">开始咨询</Button></RouterLink>
    </div>
  </div>

  <AppFooter class="mt-auto" />
</template>
